export const DECKS = {
  "Essentials": [
    { ar: "السَّلَامُ عَلَيْكُمْ", en: "Peace be upon you / Hello" },
    { ar: "وَعَلَيْكُمُ السَّلَامُ", en: "And peace be upon you (reply)" },
    { ar: "صَبَاحُ الخَيْرِ", en: "Good morning" },
    { ar: "صَبَاحُ النُّورِ", en: "Morning of light (reply)" },
    { ar: "مَسَاءُ الخَيْرِ", en: "Good evening" },
    { ar: "مَسَاءُ النُّورِ", en: "Evening of light (reply)" },

    // Original dialect greetings/phrases preserved
    { ar: "شْلُونَك؟", en: "How are you? (to a man)", dialect: true },
    { ar: "شْلُونِك؟", en: "How are you? (to a woman)", dialect: true },
    { ar: "زَيْن، الحَمْدُ لِلَّهِ", en: "Good, thank God", dialect: true },
    { ar: "تَمَام", en: "Perfect / Fine" },
    { ar: "كُلِّشْ طَيِّب", en: "Everything’s good", dialect: true }, // non-Saudi Gulf/Iraqi; kept & labeled
    { ar: "وَشِ الأَخْبَار؟", en: "What's up?", dialect: true },
    { ar: "مَا فِيهِ شَيْء", en: "Nothing's going on", dialect: true },
    { ar: "مَاشِي", en: "Okay / Fine", dialect: true },
    { ar: "خَلَاص", en: "Done / Enough", dialect: true },
    { ar: "مَا عَلَيْهِ", en: "No problem", dialect: true },

    { ar: "مَعَ السَّلَامَةِ", en: "Goodbye" },
    { ar: "اللَّهُ مَعَكَ", en: "God be with you" },
    { ar: "يَعْطِيكَ العَافِيَةَ", en: "May God grant you wellness (thanks)", dialect: true },
    { ar: "شُكْرًا", en: "Thank you" },
    { ar: "العَفْوُ", en: "You're welcome" },
    { ar: "آسِفٌ", en: "Sorry (masculine)" },
    { ar: "آسِفَةٌ", en: "Sorry (feminine)" },
    { ar: "لَوْ سَمَحْتَ", en: "Please (to a man)" },
    { ar: "لَوْ سَمَحْتِ", en: "Please (to a woman)" },
    { ar: "الحَمْدُ لِلَّهِ", en: "Praise be to God" },
    { ar: "مَا شَاءَ اللَّهُ", en: "What God has willed" },
    { ar: "إِنْ شَاءَ اللَّهُ", en: "If God wills" },
    { ar: "أَهْلًا وَسَهْلًا", en: "Welcome" },
    { ar: "هَلَا", en: "Hi / Hey", dialect: true },

    // Added clear MSA versions of “How are you?”
    { ar: "كَيْفَ حَالُكَ؟", en: "How are you? (to a man)" },
    { ar: "كَيْفَ حَالُكِ؟", en: "How are you? (to a woman)" },
    { ar: "بِخَيْرٍ، الحَمْدُ لِلَّهِ", en: "Fine, praise be to God" }
  ],

  "Conversation": [
    { ar: "صَدْق؟", en: "Really?", dialect: true },
    { ar: "وَاللَّهِ؟", en: "For real? / Seriously?", dialect: true },
    { ar: "أَيْوَه", en: "Yes", dialect: true },
    { ar: "لَا", en: "No" },
    { ar: "طَبْعًا", en: "Of course" },
    { ar: "وَشْ تَقُول؟", en: "What did you say?", dialect: true },
    { ar: "مَا سَمِعْتُ", en: "I didn't hear" },
    { ar: "مَا فَهِمْتُ", en: "I didn't understand" },
    { ar: "فَهِمْتُ", en: "I understood" },
    { ar: "مَعْلُوم", en: "Understood" },

    { ar: "اِسْتَنَّى", en: "Wait", dialect: true },
    { ar: "اِسْتَنَّى شْوَيّ", en: "Wait a bit", dialect: true },
    { ar: "رُوق", en: "Relax / Calm down", dialect: true },
    { ar: "خُذْ رَاحَتَك", en: "Take your time", dialect: true },

    { ar: "مُبْ مُمْكِن", en: "Impossible", dialect: true },
    { ar: "يُمْكِن", en: "Maybe / Possible" },
    { ar: "عَادِي", en: "It’s normal", dialect: true },
    { ar: "مَا أَدْرِي", en: "I don't know", dialect: true },

    { ar: "وَيْنَك؟", en: "Where are you?", dialect: true },
    { ar: "جَايّ الحِين", en: "I'm coming now", dialect: true },
    { ar: "خَلِّنَا نِرُوح", en: "Let's go", dialect: true },
    { ar: "يَلَّا", en: "Come on / Let's go", dialect: true },
    { ar: "تَعَال", en: "Come here" },

    { ar: "بُكْرَة", en: "Tomorrow", dialect: true },
    { ar: "الحِين", en: "Now", dialect: true },
    { ar: "بَعْدِين", en: "Later", dialect: true },
    { ar: "أَمْس", en: "Yesterday" },
    { ar: "اليَوْم", en: "Today" },

    // Added clean MSA alternatives so learners can switch
    { ar: "اِنْتَظِرْ مِنْ فَضْلِكَ", en: "Please wait (MSA)" },
    { ar: "سَأَأْتِي الآنَ", en: "I’m coming now (MSA)" },
    { ar: "هَيَّا نَذْهَبْ", en: "Let’s go (MSA)" },
    { ar: "الآنَ / غَدًا / بَعْدَ قَلِيلٍ", en: "Now / Tomorrow / In a bit (MSA)" }
  ],

  "Transport": [
    { ar: "تُوَصِّلْنِي لِلسُّوق؟", en: "Can you take me to the market?", dialect: true },
    { ar: "فِين طَرِيق المَطَار؟", en: "Where's the way to the airport?", dialect: true },
    { ar: "إِمْشِي سِيدَه", en: "Go straight ahead", dialect: true },
    { ar: "دُوغْرِي", en: "Straight (ahead)", dialect: true },
    { ar: "يَمِين", en: "Right" },
    { ar: "يَسَار", en: "Left" },
    { ar: "وَقِّفْ هِنَا", en: "Stop here", dialect: true },
    { ar: "كَمِ الأُجْرَة؟", en: "How much is the fare?" },
    { ar: "مَا مَعِي صَرْف", en: "I don't have change", dialect: true },
    { ar: "أَبْغَى أَنْزِل هِنَا", en: "I want to get off here", dialect: true },
    { ar: "اللَّه يْسَهِّلْ طَرِيقَك", en: "Have a safe trip / May God ease your way", dialect: true },

    // Nouns kept from original
    { ar: "سَيَّارَة", en: "Car" },
    { ar: "تَاكْسِي", en: "Taxi" },
    { ar: "مَطَار", en: "Airport" },
    { ar: "مَحَطَّة", en: "Station" },
    { ar: "شَارِع", en: "Street" },
    { ar: "طَرِيق", en: "Road" },

    // Added clear MSA alternatives
    { ar: "هَلْ تَسْتَطِيعُ إِيصَالِي إِلَى السُّوقِ؟", en: "Can you take me to the market? (MSA)" },
    { ar: "اِسْتَدِرْ يَمِينًا / يَسَارًا", en: "Turn right / left (MSA)" }
  ],

  "Food": [
    { ar: "وَشْ تِبَى تَأْكُل؟", en: "What do you want to eat?", dialect: true },
    { ar: "أَبْغَى آكُل", en: "I want to eat", dialect: true },
    { ar: "جُوعَان", en: "I'm hungry", dialect: true },
    { ar: "عَطْشَان", en: "I'm thirsty", dialect: true },
    { ar: "أَبْغَى مَشْوِي", en: "I want grilled food", dialect: true },
    { ar: "أَبْغَى دَجَاج", en: "I want chicken", dialect: true },
    { ar: "أَبْغَى سَمَك", en: "I want fish", dialect: true },
    { ar: "بِلَا تُبِلَة", en: "Without spice", dialect: true },
    { ar: "بِلَا سُكَّر", en: "Without sugar", dialect: true },
    { ar: "الطَّعَام لَذِيذ", en: "The food is delicious" },
    { ar: "الفَاتُورَة مِنْ فَضْلِك", en: "The bill, please" },
    { ar: "كَمِ الحِسَاب؟", en: "How much is the bill?" },
    { ar: "أَبْغَى أَدْفَع كَاش", en: "I want to pay cash", dialect: true },
    { ar: "تَقْبَلُون البِطَاقَة؟", en: "Do you accept card?", dialect: true },
    { ar: "كَمِ السِّعْر؟", en: "How much is the price?" },
    { ar: "غَالِي", en: "Expensive" },
    { ar: "رَخِيص", en: "Cheap" },
    { ar: "أَبْغَى هَذَا", en: "I want this", dialect: true },
    { ar: "عِنْدَك؟", en: "Do you have it?", dialect: true },
    { ar: "مَاء", en: "Water" },
    { ar: "قَهْوَة", en: "Coffee" },
    { ar: "شَاي", en: "Tea" },

    // Added helpful MSA buying phrases
    { ar: "هَلْ لَدَيْكُمْ قَائِمَةُ الطَّعَامِ؟", en: "Do you have a menu? (MSA)" },
    { ar: "مِنْ فَضْلِكَ، قَلِيلٌ مِنَ الحَارِّ", en: "Less spicy, please (MSA)" }
  ],

  "Daily": [
    { ar: "أَبْغَى مَاء", en: "I want water", dialect: true },
    { ar: "أَبْغَى أَنَام", en: "I want to sleep", dialect: true },
    { ar: "نَعْسَان", en: "I'm sleepy", dialect: true },
    { ar: "تَعْبَان", en: "I'm tired", dialect: true },
    { ar: "مَرِيض", en: "I'm sick" },
    { ar: "بَرْدَان", en: "I'm cold", dialect: true },
    { ar: "حَرَّان", en: "I'm hot", dialect: true },
    { ar: "وَشْ صَار؟", en: "What happened?", dialect: true },
    { ar: "فَاضِي", en: "I'm free (available)", dialect: true },
    { ar: "مُب فَاضِي", en: "I'm not free", dialect: true },
    { ar: "مَشْغُول", en: "I'm busy" },
    { ar: "بَيْت", en: "House / Home" },
    { ar: "غُرْفَة", en: "Room" },
    { ar: "حَمَّام", en: "Bathroom" },
    { ar: "صَبَاح", en: "Morning" },
    { ar: "لَيْل", en: "Night" },

    // Added polite MSA daily helpers
    { ar: "هَلْ لَدَيْكُمْ شَوَّاحِنُ؟", en: "Do you have chargers? (MSA)" },
    { ar: "أَيْنَ المَسْجِدُ الأَقْرَبُ؟", en: "Where is the nearest mosque? (MSA)" }
  ],

  "Emergency": [
    { ar: "سَاعِدْنِي!", en: "Help me!" },
    { ar: "أَنَا مَرِيض", en: "I'm sick" },
    { ar: "أَحْتَاجُ طَبِيب", en: "I need a doctor" },
    { ar: "اِتَّصِل بِالإِسْعَاف", en: "Call an ambulance" },
    { ar: "اِتَّصِل بِالشُّرْطَة", en: "Call the police" },
    { ar: "فَقَدْتُ جَوَاز السَّفَر", en: "I lost my passport" },
    { ar: "ضَاعَتْ حَقِيبَتِي", en: "My bag is lost" },
    { ar: "لَا تِقْلَق", en: "Don't worry" },
    { ar: "مُسْتَشْفَى", en: "Hospital" },
    { ar: "صَيْدَلِيَّة", en: "Pharmacy" },

    // Extra precise MSA
    { ar: "أَيْنَ أَقْرَبُ مُسْتَشْفًى؟", en: "Where is the nearest hospital? (MSA)" }
  ],

  "Family": [
    { ar: "أَبُو", en: "Father", dialect: true },
    { ar: "أُمّ", en: "Mother" },
    { ar: "أَخ", en: "Brother" },
    { ar: "أُخْت", en: "Sister" },
    { ar: "ابْن", en: "Son" },
    { ar: "بِنْت", en: "Daughter" },
    { ar: "جَدّ", en: "Grandfather" },
    { ar: "جَدَّة", en: "Grandmother" },
    { ar: "عَائِلَة", en: "Family" },
    { ar: "صَدِيق", en: "Friend" },

    // Helpful alternates
    { ar: "وَلَد / بِنْت", en: "Boy / Girl" }
  ],

  "Numbers": [
    { ar: "وَاحِد", en: "One" },
    { ar: "اِثْنَيْن", en: "Two" },
    { ar: "ثَلَاثَة", en: "Three" },
    { ar: "أَرْبَعَة", en: "Four" },
    { ar: "خَمْسَة", en: "Five" },
    { ar: "سِتَّة", en: "Six" },
    { ar: "سَبْعَة", en: "Seven" },
    { ar: "ثَمَانِيَة", en: "Eight" },
    { ar: "تِسْعَة", en: "Nine" },
    { ar: "عَشَرَة", en: "Ten" },
    { ar: "عِشْرِين", en: "Twenty", dialect: true }, // Saudi/Gulf common form for 20 is ‘عشرين’ (without kasrah on shīn in dialect)
    { ar: "مِئَة", en: "One hundred" },
    { ar: "أَلْف", en: "One thousand" }
  ],

  "Hajj & Umrah": [
    { ar: "أَبْغَى أَعْتَمِر", en: "I want to perform ʿUmrah", dialect: true },
    { ar: "أَنَا حَاجّ", en: "I am a pilgrim (male)" },
    { ar: "أَنَا حَاجَّة", en: "I am a pilgrim (female)" },

    { ar: "وَيْن الحَرَم؟", en: "Where is the Grand Mosque?", dialect: true },
    { ar: "وَيْن مَسْجِد الحَرَام؟", en: "Where is Masjid al-Ḥarām?", dialect: true },
    { ar: "وَيْن مَسْجِد النَّبَوِي؟", en: "Where is the Prophet’s Mosque?", dialect: true },
    { ar: "وَيْن المِيقَات؟", en: "Where is the mīqāt?", dialect: true },
    { ar: "أَبْغَى إِحْرَام", en: "I want iḥrām garments", dialect: true },
    { ar: "وَيْن المَطَاف؟", en: "Where is the ṭawāf area?", dialect: true },
    { ar: "وَيْن السَّعْي؟", en: "Where is the saʿy area?", dialect: true },
    { ar: "وَيْن الصَّفَا وَالمَرْوَة؟", en: "Where are Ṣafā and Marwah?", dialect: true },
    { ar: "وَيْن مَاء زَمْزَم؟", en: "Where is Zamzam water?", dialect: true },
    { ar: "مَتَى الأَذَان؟", en: "When is the adhān?" },
    { ar: "مَتَى الإِقَامَة؟", en: "When is the iqāmah?" },
    { ar: "وَيْن القِبْلَة؟", en: "Where is the qiblah?", dialect: true },
    { ar: "وَيْن دُورَات المِيَاه؟", en: "Where are the restrooms?", dialect: true },
    { ar: "وَيْن بَوَّابَة الدُّخُول؟", en: "Where is the entrance gate?", dialect: true },
    { ar: "وَيْن مَكْتَب الإِرْشَاد؟", en: "Where is the guidance office?", dialect: true },
    { ar: "وَيْن الحَافِلَات لِمِنَى؟", en: "Where are the buses to Minā?", dialect: true },
    { ar: "وَيْن مُزْدَلِفَة؟", en: "Where is Muzdalifah?", dialect: true },
    { ar: "وَيْن عَرَفَات؟", en: "Where is ʿArafāt?", dialect: true },
    { ar: "وَيْن الجَمْرَات؟", en: "Where are the Jamārāt?", dialect: true },
    { ar: "هَلْ فِيهِ زِحْمَة؟", en: "Is it crowded?", dialect: true },

    // Useful MSA adds
    { ar: "هَلْ تَوْجَدُ خِدْمَةُ نَقْلٍ؟", en: "Is there a shuttle service? (MSA)" }
  ],

  "Hotel & Travel": [
    { ar: "عِنْدِي حَجْز", en: "I have a reservation" },
    { ar: "أَبْغَى غُرْفَة", en: "I want a room", dialect: true },
    { ar: "غُرْفَة مُفْرَدَة", en: "Single room" },
    { ar: "غُرْفَة مُزْدَوِجَة", en: "Double room" },
    { ar: "كَم السِّعْر لِلَّيْلَة؟", en: "How much per night?" },
    { ar: "الفُطُور شَامِل؟", en: "Is breakfast included?", dialect: true },
    { ar: "مَتَى تَسْجِيل الدُّخُول؟", en: "When is check-in?" },
    { ar: "مَتَى تَسْجِيل الخُرُوج؟", en: "When is check-out?" },
    { ar: "وَيْن الاسْتِقْبَال؟", en: "Where is reception?", dialect: true },
    { ar: "وَيْن المِصْعَد؟", en: "Where is the elevator?", dialect: true },
    { ar: "تَنْظِيف الغُرْفَة مِنْ فَضْلِك", en: "Room cleaning, please" },
    { ar: "وَيْن المَغْسَلَة؟", en: "Where is the laundry?", dialect: true },
    { ar: "وَاي فَاي مَجَّانِي؟", en: "Is there free Wi-Fi?", dialect: true },
    { ar: "هَلْ فِيه بَاص لِلْحَرَم؟", en: "Is there a shuttle to the Haram?", dialect: true },
    { ar: "وَيْن مَوْقِف التَّاكْسِي؟", en: "Where is the taxi stand?", dialect: true },
    { ar: "بِكَم لِلْحَرَم؟", en: "How much to the Haram?", dialect: true },
    { ar: "وَيْن مَحَطَّة قِطَار الحَرَمَيْن؟", en: "Where is the Haramain train station?", dialect: true },
    { ar: "كَم التَّذْكَرَة؟", en: "How much is the ticket?" },

    // Helpful MSA adds
    { ar: "هَلْ تُوَفِّرُونَ إِلْغَاءً مَجَّانِيًّا؟", en: "Do you offer free cancellation? (MSA)" }
  ],

  "Money & SIM": [
    { ar: "أَبْغَى شِرِيحَة جَوَّال", en: "I want a SIM card", dialect: true },
    { ar: "بِكَم البَاقَة؟", en: "How much is the plan?", dialect: true },
    { ar: "إِنْتَرْنِت لَا مَحْدُود؟", en: "Unlimited internet?", dialect: true },
    { ar: "أَبْغَى أَشْحَن", en: "I want to recharge (top-up)", dialect: true },
    { ar: "وَيْن مَحَلّ الاتِّصَالَات؟", en: "Where is the phone shop?", dialect: true },
    { ar: "وَيْن صَرَّافٌ آلِيّ؟", en: "Where is an ATM?", dialect: true },
    { ar: "أَبْغَى أَصْرِف عُمْلَة", en: "I want to exchange currency", dialect: true },
    { ar: "تَقْبَلُون بَطَاقَة فِيزَا؟", en: "Do you accept Visa card?", dialect: true },
    { ar: "فَاتُورَة ضَرِيبَة مِنْ فَضْلِك", en: "Tax invoice, please" },
    { ar: "إِيصَال مُفَصَّل", en: "Itemized receipt" },

    // Useful MSA adds
    { ar: "أُرِيدُ بَاقَةَ بِيَانَاتٍ مُؤَقَّتَة", en: "I want a temporary data plan (MSA)" }
  ],

  // Extra helpful section kept (new)
  "Travel Tips (Extra)": [
    { ar: "كَمِ السَّاعَةُ؟", en: "What time is it? (MSA)" },
    { ar: "مِنْ أَيْنَ أَشْتَرِي تَذْكِرَةً؟", en: "Where can I buy a ticket? (MSA)" },
    { ar: "هَلْ هَذَا الطَّرِيقُ إِلَى مَكَّةَ؟", en: "Is this the road to Makkah? (MSA)" },
    { ar: "جَزَاكَ اللَّهُ خَيْرًا", en: "May Allah reward you with goodness" },
    { ar: "اللَّهُ يُبَارِكُ فِيكَ", en: "God bless you" },
    { ar: "مِنْ فَضْلِكَ، أَيْنَ القِبْلَةُ؟", en: "Where is the Qibla, please? (MSA)" }
  ]
};
